<template>
    <div class="detail-page">
        <div class="top-section">
            <div class="bg-img">
                <img v-if="gameInfo.cover_image_url" :src="filterImg(gameInfo.cover_image_url)" alt="" />
            </div>
            <div class="cover">
                <div class="lf-sec">
                    <div class="game-name ellipsis">{{ gameInfo.title }}</div>
                    <div class="game-en-name ellipsis">{{ gameInfo.english_title }}</div>
                </div>
                <div class="rg-sec">
                    <template v-if="Array.isArray(gameInfo.tag_List) && gameInfo.tag_List.length">
                        <span class="tag-item ellipsis" v-for="item in gameInfo.tag_List.slice().reverse()" :key="item.id">{{ item.name }}</span>
                    </template>
                </div>
            </div>
        </div>
        <div class="section-tabs">
            <segment-tab :data="navList" :titleKey="'name'" :pickIndex="navIndex" @changed="navTabChanged"></segment-tab>
        </div>
        <div class="detail-router-wrap hide-scroll">
            <transition name="fade-transform" mode="out-in">
                <component :is="currentCompName" :game-info="gameInfo" :goods-id="goods_id" @get-goods="getGoodsAndSpInfo"></component>
            </transition>
        </div>
        <div class="start-game-sec">
            <StartGameSec :game-info="gameInfo" :goods="goodsInfoAndSpInfo" :user-game-info="userGameInfo"></StartGameSec>
        </div>
    </div>
</template>
<script>
import segmentTab from '@/components/Segments/segment-tab.vue'
import StartGameSec from './subComp/StartGameSec.vue'
import { getGameInfo, getBoxUserGameInfo, boxUserGameCreate, cancelBoxUserGame } from '@/http/api/game'
import { getGoodsDetail } from '@/http/api/goods'
import { getCookieToken } from '@/utils/auth'
import GameIntro from './subPage/GameIntro.vue'

export default {
    name: 'DetailPage',
    components: { segmentTab, StartGameSec, GameIntro },
    data() {
        return {
            navList: [{ id: 1, name: '游戏特色', path: 'GameIntro' }],
            currentCompName: 'GameIntro',
            navIndex: 0,
            game_id: 0,
            goods_id: 0,
            gameInfo: {},
            userGameInfo: {},
            goodsInfoAndSpInfo: {} // 商品信息和商品规格信息
        }
    },
    computed: {
        userId: function () {
            return this.$store.state.userInfo.id
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(cur, prev) {
                if (cur && prev) {
                    const { game_id: curGameId, goods_id: curGoodsId } = cur.query
                    const { game_id: prevGameId, goods_id: prevGoodsId } = prev.query
                    if (curGameId !== prevGameId || curGoodsId !== prevGoodsId) {
                        this.initData()
                    }
                } else if (cur) {
                    this.initData()
                }
            }
        }
    },
    mounted() {
        this.$EventBus.$on('update-game-follow', (payload) => {
            this.$set(this.userGameInfo, 'id', payload.id)
        })

        this.$EventBus.$on('update-detail-follow', (payload) => {
            this.userGameInfo = {}
        })
        $('body').addClass('game-bg')
    },
    beforeDestroy() {
        this.$EventBus.$off('update-game-follow')
        this.$EventBus.$off('update-detail-follow')
        $('body').removeClass('game-bg')
    },
    methods: {
        async initData() {
            let { game_id = 0, goods_id = 0 } = this.$route.query
            try {
                // 通过乐速盒子自定义协议打开的
                if (!game_id) {
                    const res = await getGoodsDetail({ id: goods_id })
                    game_id = res.data.g_id
                    this.$EventBus.$emit('active-left-game', `${game_id}-${goods_id}`)
                }
            } catch (error) {}

            this.currentCompName = 'GameIntro'
            this.navIndex = 0
            this.navList = [{ id: 1, name: '游戏特色', path: 'GameIntro' }]
            this.game_id = parseInt(game_id)
            this.goods_id = parseInt(goods_id)
            this.gameInfo = {}
            this.userGameInfo = {}
            this.goodsInfoAndSpInfo = {}
            this.getBoxUserGameInfo()
            this.getGameInfo()
        },

        filterImg(value) {
            return this.$Utils.filterImgUrl(value)
        },
        navTabChanged(index, item) {
            this.navIndex = index
            this.currentCompName = item.path
        },
        getGameInfo() {
            getGameInfo({ id: this.game_id })
                .then((res) => {
                    if (res.code == 200 && res.data.game_id) {
                        this.gameInfo = res.data

                        this.$nextTick(() => {
                            let rgSexMaxWidth = $('.rg-sec').width(),
                                allTagItemWidth = 0
                            $.each($('.tag-item'), function (index, item) {
                                if (allTagItemWidth + item.offsetWidth + 6 <= rgSexMaxWidth) {
                                    $(item).css('visibility', 'visible')
                                    allTagItemWidth += item.offsetWidth + 6
                                }
                            })
                        })
                    }
                })
                .catch(() => {})
        },
        getGoodsAndSpInfo(value) {
            this.goodsInfoAndSpInfo = value
        },
        // 点击关注游戏按钮
        followGame() {
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.execGameCreate()
                    }
                })
            }

            this.execGameCreate()
        },
        execGameCreate() {
            if (this.requestCancel || this.requestFollow) return
            this.requestFollow = true
            boxUserGameCreate({ game_id: this.game_id, goods_id: this.goods_id })
                .then((res) => {
                    if (res.code == 200) {
                        this.$EventBus.$emit('update-user-game', { type: 'add', id: res.data.id })
                        this.$set(this.userGameInfo, 'id', res.data.id)
                        setTimeout(() => {
                            this.requestFollow = false
                        }, 1000)
                    } else {
                        this.requestFollow = false
                    }
                })
                .catch(() => {
                    this.requestFollow = false
                })
        },
        // 点击取消关注按钮
        cancelFollowGame() {
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.execCancelGame()
                    }
                })
            }

            this.execCancelGame()
        },
        execCancelGame() {
            if (this.requestCancel || this.requestFollow) return
            this.requestCancel = true
            cancelBoxUserGame({ uid: this.userId, game_id: this.game_id, goods_id: this.goods_id })
                .then((res) => {
                    if (res.code == 200) {
                        this.$EventBus.$emit('update-user-game', { type: 'remove', id: res.data.id })
                        this.userGameInfo = {}
                        setTimeout(() => {
                            this.requestCancel = false
                        }, 1000)
                    } else {
                        this.requestCancel = false
                    }
                })
                .catch(() => {
                    this.requestCancel = false
                })
        },
        getBoxUserGameInfo() {
            if (!getCookieToken()) {
                return false
            }
            getBoxUserGameInfo({ game_id: this.game_id, goods_id: this.goods_id }).then((res) => {
                if (res.code == 200) {
                    this.userGameInfo = res.data
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.detail-page {
    margin: 0 auto;
    padding-top: 140px;
    width: @main-width;
    color: @color-txt-high;
    position: relative;

    .top-section {
        position: relative;
        height: 90px;
        overflow: hidden;
        border-radius: 10px;
        margin-bottom: 30px;

        .bg-img {
            width: 100%;
            height: 100%;
            filter: blur(5px);

            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .cover {
            display: flex;
            justify-content: space-between;
            position: absolute;
            padding: 20px 20px 0;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(30, 30, 30, 0.8);

            .lf-sec {
                width: 50%;
                flex-shrink: 0;

                .game-name {
                    font-size: 24px;
                    font-weight: bold;
                    line-height: 24px;
                    margin-bottom: 14px;
                }

                .game-en-name {
                    font-size: 14px;
                }
            }

            .rg-sec {
                width: 50%;
                display: flex;
                align-items: center;
                overflow: hidden;
                flex-direction: row-reverse;

                .tag-item {
                    margin-left: 6px;
                    display: inline-block;
                    padding: 0 11px;
                    text-align: center;
                    flex-shrink: 0;
                    height: 26px;
                    font-size: 14px;
                    line-height: 26px;
                    background: @bg-color-33;
                    border-radius: 13px;
                    color: @color-txt-normal;
                    visibility: hidden;

                    &:last-child {
                        margin-left: 0;
                    }
                }

                .follow {
                    flex-shrink: 0;
                    cursor: pointer;
                    margin-left: 14px;
                    .flex-center();
                    width: 80px;
                    height: 30px;
                    border-radius: 15px;
                    font-size: 14px;
                    color: @bg-color-00;

                    &.follow-true {
                        background: linear-gradient(133deg, rgba(0, 241, 78, 0.8), rgba(2, 203, 138, 0.8));

                        &:hover {
                            background: linear-gradient(133deg, #00f14e, #02cb8a);
                        }
                    }

                    &.follow-false {
                        color: @bg-color-cc;
                        background-color: @color-txt-66;
                    }
                }
            }
        }
    }

    .section-tabs {
        padding-left: 8px;
        margin-bottom: 20px;
    }

    .detail-router-wrap {
        height: calc(100% - 174px);
        overflow-y: auto;
        padding-bottom: 60px;
    }

    .start-game-sec {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1;
    }
}
</style>
